/**
 * National Provider Identifier (NPI) utilities.
 *
 * Configured to allow up to 10 digits without strict checksum restrictions,
 * ensuring users can freely input provider NPIs up to 10 characters.
 */

/**
 * Validates whether a given string is a valid numeric NPI up to 10 digits.
 */
export const isValidNpi = (npi?: string | null): boolean => {
  if (!npi || typeof npi !== "string") return false;
  const trimmed = npi.trim();
  return /^\d{1,10}$/.test(trimmed);
};

/**
 * Validates an NPI input value.
 *
 * @param val The input value to validate
 * @param isRequired Whether the field is mandatory
 * @param requiredMessage Custom message when mandatory and empty
 * @returns Error message string or empty string if valid
 */
export const validateNpi = (
  val?: string | null,
  isRequired = false,
  requiredMessage = "Billing Provider NPI is required."
): string => {
  if (!val || !val.trim()) {
    return isRequired ? requiredMessage : "";
  }
  return "";
};
